<template>
  <div class="modal-card" style="margin: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("vending.addProduct") }}
      </p>
    </header>

    <section class="modal-card-body has-text-centered">
      <p style="margin-bottom: 1rem;">
        {{ $t("vending.howToAddProduct") }}
      </p>

      <b-field class="barcode-search">
        <b-input
          v-model="barcode"
          :placeholder="$t('vending.code')"
          type="tel"
          icon="barcode"
          @input.native="formatOnlyDigits('barcode')"
          @input="clearFields"
          @keyup.native.enter="searchProduct"
        ></b-input>

        <p class="control">
          <button class="button is-info" @click="searchProduct">
            {{ $t("vending.search") }}
          </button>
        </p>
      </b-field>

      <p v-if="productNotFound">
        {{ $t("vending.confirmBarcodeOr") }}
        <router-link to="/product-creation">
          {{ $t("vending.createNewProduct") }}
        </router-link>
      </p>

      <div v-if="product.n">
        <p>
          {{ $t("vending.productFound") }}
          <b-icon
            icon="check"
            type="is-success"
            style="position: relative; top: 2px;"
          ></b-icon>
        </p>

        <p style="margin-top: 1rem;">
          <b>{{ product.n }}</b>
        </p>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        :disabled="!product.n"
        class="button is-primary"
        type="button"
        @click="addVendingProduct"
      >
        {{ $t("common.add") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";

export default {
  props: ["categoryId", "vendingId"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      barcode: "",
      product: {},
      productNotFound: false
    };
  },

  methods: {
    clearFields() {
      this.productNotFound = false;
      this.product = {};
    },

    searchProduct() {
      if (!/\d+|^CB+\d+$/.test(this.barcode)) {
        this.alertError({ message: "INVALID_BARCODE" });
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch("searchProduct", { barcode: this.barcode })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
            if (res.data.message === "PRODUCT_NOT_FOUND") {
              this.productNotFound = true;
            }
          } else {
            this.product = res.data.payload.product;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addVendingProduct() {
      this.isLoading = true;
      this.$store
        .dispatch("addVendingProduct", {
          product: this.product,
          vendingId: this.vendingId,
          categoryId: this.categoryId
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("update-vending");
            this.$parent.close();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.barcode-search {
  max-width: 320px;
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
